//get access token from local storage
export const getLocalAccessToken = () => {
  const accessToken = window.localStorage.getItem("accessToken");
  return accessToken;
};

export const setLocalAccessToken = (accessToken) => {
  window.localStorage.setItem("accessToken", accessToken);
};


export const clearTokensFromStorage = () => {
  window.localStorage.removeItem("accessToken");
  // To be refactored
  window.localStorage.removeItem('persist:auth');
  window.localStorage.removeItem('persist:candidateAuth');
};
